// extracted by mini-css-extract-plugin
export var hoverZoomImage = "HoverZoomImage-module--hoverZoomImage--rGlly";